import {
  FETCH_WEATHER_STATION_DATASTREAM_MEASURE_FAILURE,
  FETCH_WEATHER_STATION_DATASTREAM_MEASURE_REQUEST,
  FETCH_WEATHER_STATION_DATASTREAM_MEASURE_SUCCESS,
} from "../actions/weatherStationTimeRangeMeasure.actions";

const initialState = {
  data: null,
  loading: false,
};

const weatherStationDatastreamMeasureData = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WEATHER_STATION_DATASTREAM_MEASURE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_WEATHER_STATION_DATASTREAM_MEASURE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case FETCH_WEATHER_STATION_DATASTREAM_MEASURE_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default weatherStationDatastreamMeasureData;
